import { ReportService } from "./types";

export const reportService: ReportService = {
	list: ({ startDate, endDate, laundryUnitId, deviceId }) => ({
		method: "GET",
		path: `/v1/weekly-report/device/startDay/${startDate}/endDay/${endDate}/laundryUnitId/${laundryUnitId}/device/${deviceId}`,
	}),
};
